import { Box } from "@stenajs-webui/core";
import type { TextInputButtonSize } from "@stenajs-webui/elements";
import type { FC, ReactNode } from "react";

import { stopPropagation } from "../../common/eventHelpers";
import type { Placement } from "../popover/FreightPortalPopover";
import { PopoverBody } from "../popover/PopoverBody";
import { PopoverTitle } from "../popover/PopoverTitle";
import { InformationMessageIconPopover } from "./InformationMessageIconPopover";
import { InformationMessageType } from "./informationMessageUtils";

export interface RegistrationNumberAlertInformationIconProps {
  buttonSize?: TextInputButtonSize;
  iconType: InformationMessageType;
  onClick?: () => void;
  placement?: Placement;
  renderPopupContent: (requestClose: () => void) => ReactNode;
  title?: string;
}

export const RegistrationNumberAlertIcon: FC<
  RegistrationNumberAlertInformationIconProps
> = ({
  title,
  iconType = InformationMessageType.RegularInfo,
  buttonSize = "medium",
  placement = "right",
  onClick,
  renderPopupContent,
}) => {
  return (
    <InformationMessageIconPopover
      iconType={iconType}
      buttonSize={buttonSize}
      placement={placement}
      onOpened={onClick}
    >
      {({ onRequestClose }) => (
        <Box
          className="t_portal_popover"
          minWidth={240}
          maxWidth={420}
          onDoubleClick={stopPropagation}
        >
          <PopoverTitle text={title} onClose={onRequestClose} />
          <PopoverBody>{renderPopupContent(onRequestClose)}</PopoverBody>
        </Box>
      )}
    </InformationMessageIconPopover>
  );
};
